import { Box } from '@mui/material';
import { useState } from 'react';
import { useSwipeable } from 'react-swipeable';
import { StyleObj } from '../../@types';
import useBreakpoints from '../../hooks/useBreakpoints';
import { useNavigate } from 'react-router';
import Logo from './Logo';

const styles: StyleObj = {
  logo: {
    borderRadius: 2,
    cursor: 'pointer',
  },
  container: {
    transition: 'transform 0.3s ease-out',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

const MAX_SWIPE_OFFSET = 25;

const SwipeableLogo = ({ size = 'medium' }: { size?: 'small' | 'medium' }) => {
  const [swipeOffset, setSwipeOffset] = useState(0);

  const navigate = useNavigate();
  const { isMobile } = useBreakpoints();

  const handleLogoSwipeEnd = () => {
    if (isMobile) {
      navigate('/search');
    }
    setSwipeOffset(0);
  };

  const handleClick = () => {
    navigate('/sports');
  };

  const handlers = useSwipeable({
    onSwiping: (event) => {
      if (isMobile) {
        const newOffset = Math.min(Math.abs(event.deltaX), MAX_SWIPE_OFFSET);
        setSwipeOffset(event.dir === 'Left' ? -newOffset : newOffset);
      }
    },
    onSwiped: handleLogoSwipeEnd,
    trackMouse: true,
  });

  return (
    <Box sx={styles.logo} {...handlers} onClick={handleClick}>
      <Box
        sx={{
          ...styles.container,
          transform: `translateX(${swipeOffset}px)`,
        }}
      >
        <Logo size={size} />
      </Box>
    </Box>
  );
};

export default SwipeableLogo;
